import React, { useEffect } from 'react';
import { useAuthContext } from 'AuthContext';
import routes from 'store/configs/Routes';
import { Navigate } from 'react-router-dom';
import SpinnerComponent from './SpinnerComponent';

interface LoginComponentProps {
  loggedOut?: boolean;
}

const LogoutComponent: React.FunctionComponent<LoginComponentProps> = ({ loggedOut }) => {
  const { logout } = useAuthContext();
  useEffect(() => {
    logout();
  }, [logout]);

  return loggedOut ? <Navigate to={routes.home} /> : <SpinnerComponent visible={true} />;
};

export default LogoutComponent;
